<template>
  <slot :hasPower="hasPower"/>
</template>

<script lang="ts" setup>
import {inject, onMounted, ref, watch} from "vue";
import {Framework} from "./proto/proto";

const props = defineProps({
  /** 模块 */
  Module: String,
  Action: Framework.Operating,
})


const verifyPower = inject("verifyPower") as any;
const CurrentUserInfo = inject("CurrentUserInfo") as any;
const RootModules = inject("RootModules") as any;
const SubModules = inject("SubModules") as any;

const hasPower = ref(false);

onMounted(() => {
  if (verifyPower)
    hasPower.value = verifyPower(props.Module, props.Action)
})

watch(() => CurrentUserInfo.value, () => {
  if (verifyPower)
    hasPower.value = verifyPower(props.Module, props.Action)
})
watch(() => RootModules.value, () => {
  if (verifyPower)
    hasPower.value = verifyPower(props.Module, props.Action)
})
watch(() => SubModules.value, () => {
  if (verifyPower)
    hasPower.value = verifyPower(props.Module, props.Action)
})


</script>